<template>
  <div>
    <div class="card card-custom">
      <div class="card-header">
        <h3 class="card-title" style="width: 100%">
          <button onclick="javascript:location.href='../UIC/BasicClientProfile'" type="button" class=" float-left btn btn-sm btn-outline-secondary btn-default"> <i class="fa fa-plus"> Add New</i></button>
        </h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="form-group col-md-3">
            <label class="form-label">Partner Type</label>
            <v-select placeholder="--Select--" label="Title" :options="partnerTypes" v-model="form.PTR_ID" :reduce="x=>x.ID" />
          </div>
          <div class="form-group col-md-3">
            <label class="form-label">Status</label>
            <v-select placeholder="--Select--" label="Title" :options="statuses" v-model="form.PST_ID" :reduce="x=>x.ID" />
          </div>
          <div class="form-group col-md-3">
            <label class="form-label">Tax</label>
            <v-select placeholder="--Select--" label="Title" :options="taxes" v-model="form.TX_ID" :reduce="x=>x.ID" />
          </div>
          <div class="form-group col-md-3">
            <label class="form-label">Business Nature</label>
            <v-select placeholder="--Select--" label="Title" :options="businessNatures" v-model="form.BN_ID" :reduce="x=>x.ID" />
          </div>
          <div class="form-group col-md-3">
            <label class="form-label">Client Status</label>
            <v-select :options="clientStatus" label="Title" :reduce="x => x.ID" v-model="form.BP_ACTIVE" placeholder="--Select--" />
          </div>
          <div class="form-group col-md-3">
            <button type="button" class="btn btn-success float-left mr-1" v-on:click="load()">Load</button>
          </div>
        </div>
        <table class="table table-sm table-bordered" id="myTable">
          <thead class="bg-custom">
            <tr>
              <th width="5px">Sr.</th>
              <th width="8%">Client Code</th>
              <th width="20%">Name</th>
              <th width="15%">Partner Type</th>
              <th width="6%">City</th>
              <th width="10%">Business Nature</th>
              <th width="10%">Address</th>
              <th width="10%">Mobile No</th>
              <th width="10%">GST</th>
              <th width="10%">CNIC</th>
              <th width="10%">NTN</th>
              <th width="5%">Attachment</th>
              <th width="5%">Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,ind) in list" :key="ind">
              <td>{{ind + 1}}</td>
              <td>{{item.BP_CODE_NEW}}</td>
              <td>{{item.BP_DSC}}</td>
              <td>{{item.PTR_TYPE}}</td>
              <td>{{item.City}}</td>
              <td>{{item.BN_DESC}}</td>
              <td>{{item.Addresses}}</td>
              <td>{{item.BP_MOBILE}}</td>
              <td>{{item.BP_GST_NO}}</td>
              <td>{{item.BP_NIC_NO}}</td>
              <td>{{item.BP_NTN_NO}}</td>
              <td style="text-align:center">
                <span v-if="item.HAS_ATTACHMENTS" title="Has Attachments"><i class="fa fa-paperclip text-primary"></i></span>
              </td>
              <td><input type="checkbox" :checked="item.BP_ACTIVE == 1" disabled></td>
              <td>
                <button class="btn btn-primary btn-sm" @click="editInsured(item.BP_ID, item.PTR_ID)"><i class="fas fa-pencil-alt" /></button>
                <button class="btn btn-success btn-sm" @click="printKyc(item.BP_ID, item.PTR_ID)"><i class="fas fa-download" /></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  export default ({
    data() {
      return {
        form: {
          PTR_ID: null,
          PST_ID: null,
          TX_ID: null,
          BN_ID: null,
          BP_ACTIVE: null,
        },
        clientStatus: [
          //{ ID: -1, Title: "All" },
          { ID: 1, Title: "Active" },
          { ID: 0, Title: "Inactive" }
        ],
        partnerTypes: [],
        statuses: [],
        taxes: [],
        businessNatures: [],
        list: [],
      };
    },

    updated() {
      $("#myTable").DataTable();
    },
    created() {
      this.pageload();
    },
    methods: {
      pageload() {
        var vm = this;
        startReq();
        const urlParams = new URLSearchParams(window.location.search);
        let ptrId = urlParams.get('PTR_ID') ? parseInt(urlParams.get('PTR_ID')) : null;
        axios.get("/api/UICApi/pageLoadClientList", { params: { PTR_ID: ptrId } })
          .then(function (res) {
            endReq();
            vm.list = res.data.list;
            console.log("First item:", vm.list[0]);
            vm.partnerTypes = res.data.partnerTypes;
            vm.statuses = res.data.statuses;
            vm.taxes = res.data.taxes;
            vm.businessNatures = res.data.businessNatures;
          })
          .catch((error) => {
            endReq();
            console.log(error);
          })
      },
      editInsured(id, ptrId) {
        if (ptrId === 17 || ptrId === 1) {
          window.open("/uic/IndividualProfile?id=" + id);
        } else {
          window.open("/uic/CorporateProfile?id=" + id);
        }
      },
      printKyc(id, ptrId) {
        if (ptrId === 17 || ptrId === 1) {
          window.open("/UIC/IndividualClientPrint?id=" + id);
        } else {
          window.open("/UIC/CorporateClientPrint?id=" + id);
        }
      },
      load() {
        var vm = this;
        startReq();
        axios.get("/api/UICApi/LoadClientList", {
          params: {
            PTR_ID: vm.form.PTR_ID,
            PST_ID: vm.form.PST_ID,
            TX_ID: vm.form.TX_ID,
            BN_ID: vm.form.BN_ID,
            BP_ACTIVE: (vm.form.BP_ACTIVE !== null && vm.form.BP_ACTIVE !== undefined) ? vm.form.BP_ACTIVE : -1
          }
        })
          .then(function (res) {
            endReq();
            vm.list = res.data.list;
            var table = $("#myTable").DataTable();
            table.destroy();
          })
          .catch((error) => {
            endReq();
            console.log(error);
          })
      },
    },
  })
</script>



// WEBPACK FOOTER //
// src/components/ims/BasicClientProfileList.vue